// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13kZ_","badges":"styles_badges__T7sJg"};